import React, { useEffect, useState } from 'react';
import userStyle from './UserProfilePage.module.css'
import CoordinatorHeader from '../../components/Header/CoordinatorHeader'
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar'
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import SideBar from '../../components/SideBar/SideBar'
import withReactContent from 'sweetalert2-react-content';
import { useParams, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import Swal from "sweetalert2";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { setCoordinator } from '../../../redux/slices/coordinatorSlices';
import { logoutCoordinator } from '../../../redux/slices/coordinatorSlices';
require('typeface-poppins')

export default function UserProfilePage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);



  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [pId, profileId] = useState(true);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({
    f_name: "",
    l_name: "",
    position: "",
    email_id: "",
    phone: "",
    organization_name: "",
    st_address: "",
    city: "",
    password: "",
    zipcode: "",
    confirmPassword: "",
    id: id,
    profile_image: "",
    organization_image: ""
  });

  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [zipError, setZipError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  // Add state for profile image
  const [profileImage, setProfileImage] = useState(null);
  // Add state for organization image
  const [organizationImage, setOrganizationImage] = useState(null);

  // Add state for profile image file
  const [profileImageFile, setProfileImageFile] = useState(null);
  // Add state for organization image file
  const [organizationImageFile, setOrganizationImageFile] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_data.php?id=${id}`);
        if (response.data.success) {
          setUser(response.data.user);
          dispatch(setCoordinator({
            id: response.data.user.cordinator_id,
            fName: response.data.user.f_name,
            lName: response.data.user.l_name,
            email: response.data.user.email,
            position: response.data.user.position,
            pic: response.data.user.profile_pic,
          }));
          if (response.data.user.profile_pic) {
            setProfileImage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/${response.data.user.profile_pic}`);
          }
          if (response.data.user.organization_logo) {
            setOrganizationImage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/${response.data.user.organization_logo}`);
          }
        } else {
          setError(response.data.message);
          navigate(`/`);
          alert('User either Deactivated or Deleted');
        }
      } catch (err) {
        setError("Failed to fetch user details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchUserDetails();
  }, [id]);

  if (loading) {
    return <div></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Handler to update user data
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'phone') {
  //     // Remove any non-digit characters
  //     const phoneValue = value.replace(/\D/g, '');

  //     // Validate phone length
  //     if (phoneValue.length < 10) {
  //       setPhoneError("Phone number must be at least 10 digits");
  //     } else if (phoneValue.length > 15) {
  //       setPhoneError("Phone number cannot exceed 15 digits");
  //     } else {
  //       setPhoneError("");
  //     }

  //     setUser((prevUser) => ({
  //       ...prevUser,
  //       [name]: phoneValue
  //     }));
  //   } else if (name === 'email_id') {
  //     // Count @ symbols in email
  //     const atSymbolCount = (value.match(/@/g) || []).length;

  //     if (atSymbolCount > 1) {
  //       setEmailError("Email can only contain one @ symbol");
  //     } else {
  //       setEmailError("");
  //     }

  //     setUser((prevUser) => ({
  //       ...prevUser,
  //       [name]: value
  //     }));
  //   } else if (name === 'zipcode') {
  //     // Remove any non-digit characters
  //     const zipValue = value.replace(/\D/g, '');

  //     if (zipValue.length > 9) {
  //       setZipError("Zip code cannot exceed 9 digits");
  //     } else {
  //       setZipError("");
  //     }

  //     setUser((prevUser) => ({
  //       ...prevUser,
  //       [name]: zipValue
  //     }));
  //   } else if (name === 'password' || name === 'confirmPassword') {
  //     const updatedUser = {
  //       ...user,
  //       [name]: value
  //     };

  //     // Check if both password fields have values and validate match
  //     if (name === 'password' && updatedUser.confirmPassword) {
  //       if (value !== updatedUser.confirmPassword) {
  //         setPasswordError("Passwords do not match");
  //       } else {
  //         setPasswordError("");
  //       }
  //     } else if (name === 'confirmPassword' && updatedUser.password) {
  //       if (value !== updatedUser.password) {
  //         setPasswordError("Passwords do not match");
  //       } else {
  //         setPasswordError("");
  //       }
  //     }

  //     setUser(updatedUser);
  //   } else {
  //     setUser((prevUser) => ({
  //       ...prevUser,
  //       [name]: value
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      // Remove non-digit characters
      const phoneValue = value.replace(/\D/g, '');

      // Validate phone length
      if (phoneValue.length < 10) {
        setPhoneError("Phone number must be at least 10 digits");
      } else if (phoneValue.length > 15) {
        setPhoneError("Phone number cannot exceed 15 digits");
      } else {
        setPhoneError("");
      }

      setUser((prevUser) => ({
        ...prevUser,
        [name]: phoneValue,
      }));

    } else if (name === 'email_id') {
      // Validate email for multiple @
      const atSymbolCount = (value.match(/@/g) || []).length;

      if (atSymbolCount > 1) {
        setEmailError("Email can only contain one @ symbol");
      } else {
        setEmailError("");
      }

      setUser((prevUser) => ({
        ...prevUser,
        [name]: value,
      }));

    } else if (name === 'zipcode') {
      // Remove non-digit characters
      const zipValue = value.replace(/\D/g, '');

      if (zipValue.length > 9) {
        setZipError("Zip code cannot exceed 9 digits");
      } else {
        setZipError("");
      }

      setUser((prevUser) => ({
        ...prevUser,
        [name]: zipValue,
      }));

    } else if (name === 'password') {
      setUser((prevUser) => {
        const updatedUser = {
          ...prevUser,
          password: value,
          confirmPassword: value, // Auto-fill confirmPassword
        };

        return updatedUser;
      });

      setPasswordError('');
    } else if (name === 'confirmPassword') {
      setUser((prevUser) => ({
        ...prevUser,
        confirmPassword: value,
      }));

      // Moved outside to compare current password and input value
      if (value !== user.password) {
        setPasswordError("Passwords do not match");
      } else {
        setPasswordError("");
      }
    } else {
      // For all other fields
      setUser((prevUser) => ({
        ...prevUser,
        [name]: value,
      }));
    }
  };


  // Modify profile image handler to store the file
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
      setProfileImageFile(file);
    }
  };

  // Modify organization image handler to store the file
  const handleOrganizationImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setOrganizationImage(URL.createObjectURL(file));
      setOrganizationImageFile(file);
    }
  };

  // Handler for form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate phone number
    if (user.phone.length < 10) {
      setPhoneError("Phone number must be at least 10 digits");
      return;
    }

    if (user.phone.length > 15) {
      setPhoneError("Phone number cannot exceed 15 digits");
      return;
    }

    // Validate email
    const atSymbolCount = (user.email_id.match(/@/g) || []).length;
    if (atSymbolCount > 1) {
      setEmailError("Email can only contain one @ symbol");
      return;
    }

    // Validate zip code
    if (user.zipcode.length > 9) {
      setZipError("Zip code cannot exceed 9 digits");
      return;
    }

    // Validate passwords match if either password field is filled
    if ((user.password || user.confirmPassword) && user.password !== user.confirmPassword) {
      setPasswordError("Passwords do not match1");
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    // Profile image validation
    if (profileImageFile) {
      if (!allowedTypes.includes(profileImageFile.type)) {
        Swal.fire({
          title: "Invalid File Type!",
          text: "Profile image must be a JPG or PNG file.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
      if (profileImageFile.size > maxFileSize) {
        Swal.fire({
          title: "File Too Large!",
          text: "Profile image must not exceed 5 MB.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    // Organization image validation
    if (organizationImageFile) {
      if (!allowedTypes.includes(organizationImageFile.type)) {
        Swal.fire({
          title: "Invalid File Type!",
          text: "Organization image must be a JPG or PNG file.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
      if (organizationImageFile.size > maxFileSize) {
        Swal.fire({
          title: "File Too Large!",
          text: "Organization image must not exceed 5 MB.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }
    }

    // Create FormData object
    const formData = new FormData();

    // Append all user data
    Object.keys(user).forEach(key => {
      if (key !== 'profile_image' && key !== 'organization_image') {
        formData.append(key, user[key]);
      }
    });

    // Append images if they exist
    if (profileImageFile) {
      formData.append('profile_image', profileImageFile);
    }
    if (organizationImageFile) {
      formData.append('organization_image', organizationImageFile);
    }

    fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/cordinator_profile_update.php`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data.user_id);

        if (data.user_id && data.f_name && data.l_name) {
          // Update Redux state
          // dispatch(logoutCoordinator()); // If needed — or remove if not required
          dispatch(setCoordinator({
            id: data.user_id,
            fName: data.f_name,
            lName: data.l_name,
            email: data.email,
            position: data.position,
            pic: data.pic,
          }));

          // Show success popup
          Swal.fire({
            title: "Profile is successfully updated!",
            text: "Redirecting to your profile...",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            navigate(`/user-profile/${data.user_id}`);
            window.location.reload();
          });
        } else {
          throw new Error("Incomplete user data received");
        }
      })
      .catch(error => {
        console.error('Error:', error);
        Swal.fire({
          title: "Error!",
          text: "Failed to update profile. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        });
      });

  };

  return (
    <>
      <CoordinatorHeader />
      {isMobile ? (
        <div className={userStyle.mobilprofiletopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorMobilPageBar />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={userStyle.desktopprofiletopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorPageBar />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <div className={userStyle.mobiluserprofilepage}>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <h4>Account Profile</h4>
                <div className={userStyle.userprofilepagemobilContent}>
                  <div className='row'>
                    <div className="col-12">
                      <div className={userStyle.profilepagemobilUpload}>
                        <div className={userStyle.profilepagemobilEdit}>
                          <input type="file" className={userStyle.profilepagemobilInput} id="profilepagemobilUpload" accept=".png, .jpg, .jpeg" />
                          <label htmlFor="profilepagemobilUpload"></label>
                        </div>
                        <div className={userStyle.profilepagemobilPreview}>
                          <div id="profilemobilpreview"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row g-1 mb-2'>
                    <div className="col-6">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>First Name</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.f_name} name="f_name" placeholder="First name" />
                    </div>
                    <div className="col-6">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Last Name</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.l_name} name="l_name" placeholder="Last name" />
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Position</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.position} name="position" placeholder="Position" />
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Email Address</label>
                      <input
                        type="email"
                        className={`${userStyle.profilepagemobilInputs} form-control ${emailError ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        value={user.email_id}
                        name="email_id"
                        placeholder="Email Address"
                      />
                      {emailError && (
                        <div className="invalid-feedback">
                          {emailError}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Phone Number</label>
                      <input
                        type="tel"
                        className={`${userStyle.profilepagemobilInputs} form-control ${phoneError ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        value={user.phone}
                        name="phone"
                        placeholder="123-456-7890"
                        minLength="10"
                        maxLength="15"
                      />
                      {phoneError && (
                        <div className="invalid-feedback">
                          {phoneError}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className="col-12">
                      <hr />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="col-12">
                      <div className={userStyle.profilepagemobilUpload}>
                        <div className={userStyle.profilepagemobilEdit}>
                          <input type="file" className={userStyle.profilepagemobilInput} id="profileUpload1" accept=".png, .jpg, .jpeg" />
                          <label htmlFor="profileUpload1"></label>
                        </div>
                        <div className={userStyle.profilepagemobilPreview}>
                          <div id="profilepreview1"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>School/Organization</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.organization_name} name="organization_name" placeholder="" />
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Street Address</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.st_address} name="st_address" placeholder="" />
                    </div>
                  </div>
                  <div className='row g-2 mb-2'>
                    <div className="col-5">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>City</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.city} name="city" placeholder="" />
                    </div>
                    <div className="col-3">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>State</label>
                      <select className={`${userStyle.profilepagemobilSelect} form-select`} onChange={handleChange} value={user.state || ""} name="state" >
                        <option> -Select- </option>
                        <option value="Alabama-AL"> Alabama </option>
                        <option value="Arizona-AZ"> Arizona </option>
                        <option value="Arkansas-AR"> Arkansas </option>
                        <option value="California-CA"> California </option>
                        <option value="Colorado-CO"> Colorado </option>
                        <option value="Connecticut-CT"> Connecticut </option>
                        <option value="Delaware-DE"> Delaware </option>
                        <option value="Florida-FL"> Florida </option>
                        <option value="Georgia-GA"> Georgia </option>
                        <option value="Idaho-ID"> Idaho </option>
                        <option value="Illinois-IL"> Illinois </option>
                        <option value="Indiana-IN"> Indiana </option>
                        <option value="Iowa-IA"> Iowa </option>
                        <option value="Kansas-KS"> Kansas </option>
                        <option value="Kentucky-KY"> Kentucky </option>
                        <option value="Louisiana-LA"> Louisiana </option>
                        <option value="Maine-ME"> Maine </option>
                        <option value="Maryland-MD"> Maryland </option>
                        <option value="Massachusetts-MA"> Massachusetts </option>
                        <option value="Michigan-MI"> Michigan </option>
                        <option value="Minnesota-MN"> Minnesota </option>
                        <option value="Mississippi-MS"> Mississippi </option>
                        <option value="Missouri-MO"> Missouri </option>
                        <option value="Montana-MT"> Montana </option>
                        <option value="Nebraska-NE"> Nebraska </option>
                        <option value="Nevada-NV"> Nevada </option>
                        <option value="New Hampshire-NH"> New Hampshire </option>
                        <option value="New Jersey-NJ"> New Jersey </option>
                        <option value="New Mexico-NM"> New Mexico </option>
                        <option value="New York-NY"> New York </option>
                        <option value="North Carolina-NC"> North Carolina </option>
                        <option value="North Dakota-ND"> North Dakota </option>
                        <option value="Ohio-OH"> Ohio </option>
                        <option value="Oklahoma-OK"> Oklahoma </option>
                        <option value="Oregon-OR"> Oregon </option>
                        <option value="Pennsylvania-PA"> Pennsylvania </option>
                        <option value="Rhode Island-RI"> Rhode Island </option>
                        <option value="South Carolina-SC"> South Carolina </option>
                        <option value="South Dakota-SD"> South Dakota </option>
                        <option value="Tennessee-TN"> Tennessee </option>
                        <option value="Texas-TX"> Texas </option>
                        <option value="Utah-UT"> Utah </option>
                        <option value="Vermont-VT"> Vermont </option>
                        <option value="Virginia-VA"> Virginia </option>
                        <option value="Washington-WA"> Washington </option>
                        <option value="West Virginia-WV"> West Virginia </option>
                        <option value="Wisconsin-WI"> Wisconsin </option>
                        <option value="Wyoming-WY"> Wyoming </option>
                        <option value="District of Columbia-DC"> District of Columbia </option>
                      </select>
                    </div>
                    <div className="col-4">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Zip</label>
                      <input
                        type="text"
                        className={`${userStyle.profilepagemobilInputs} form-control ${zipError ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        value={user.zipcode}
                        name="zipcode"
                        placeholder=""
                        maxLength="9"
                      />
                      {zipError && (
                        <div className="invalid-feedback">
                          {zipError}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className="col-12">
                      <hr />
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <div className="col-12">
                      <label className={`${userStyle.profilepagemobileLabel} form-label`}>Username</label>
                      <input type="text" className={`${userStyle.profilepagemobilInputs} form-control`} onChange={handleChange} value={user.email_id} name="email_id" placeholder="" />
                    </div>
                  </div>
                  <div className="col-12 mb-2">
                    <label className={`${userStyle.profilepagemobileLabel} form-label`}>Password</label>
                    <div className={userStyle.profilepasswordWrapper}>
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        id="password"
                        className={`${userStyle.profilepagemobilInputs} form-control ${passwordError ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        value={user.password}
                        name="password"
                      />
                      <div className={userStyle.profiletoggleButton} onClick={togglePasswordVisibility}>
                        {isPasswordVisible ? <FaEyeSlash className={userStyle.profileIconeye} /> : <FaEye className={userStyle.profileIconeye} />}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className={`${userStyle.profilepagemobileLabel} form-label`}>Confirm Password</label>
                    <div className={userStyle.profilepasswordWrapper}>
                      <input
                        type={isCPasswordVisible ? "text" : "password"}
                        id="password"
                        className={`${userStyle.profilepagemobilInputs} form-control ${passwordError ? 'is-invalid' : ''}`}
                        onChange={handleChange}
                        value={user.confirmPassword}
                        name="confirmPassword"
                      />
                      <div className={userStyle.profiletoggleButton} onClick={toggleCPasswordVisibility}>
                        {isCPasswordVisible ? <FaEyeSlash className={userStyle.profileIconeye} /> : <FaEye className={userStyle.profileIconeye} />}
                      </div>
                    </div>
                    {passwordError && (
                      <div className="invalid-feedback d-block">
                        {passwordError}
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-4'>
                  <div className="col-12 text-center">
                    <button className={`${userStyle.profilemainmobilButton} btn btn-primary w-100`}>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={userStyle.userprofilepage}>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar />
              </div>
              <div className="col">
                <div className={userStyle.userprofilepageContent}>
                  <h4>Profile Information</h4>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-xl-3">
                        <div className={userStyle.profilepageUpload}>
                          <div className={userStyle.profilepageEdit}>
                            <input
                              type="file"
                              className={userStyle.profilepageInput}
                              id="profilepageUpload"
                              accept=".png, .jpg, .jpeg"
                              onChange={handleProfileImageChange}
                            />
                            <label htmlFor="profilepageUpload"></label>
                          </div>
                          <div className={userStyle.profilepagePreview}>
                            <div id="profilepreview">
                              {profileImage && (
                                <img
                                  src={profileImage}
                                  alt="Profile Preview"
                                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-9">
                        <div className={userStyle.userprofileMainpart}>
                          <div className="row">
                            <div className="col mb-3">
                              <label className={`${userStyle.profilepageLabel} form-label`}>First Name</label>
                              <input type="text" className={`${userStyle.profilepageInputs} form-control`} onChange={handleChange} value={user.f_name} name="f_name" placeholder="First name" />
                            </div>
                            <div className="col mb-3">
                              <label className={`${userStyle.profilepageLabel} form-label`}>Last Name</label>
                              <input type="text" className={`${userStyle.profilepageInputs} form-control`} onChange={handleChange} value={user.l_name} name="l_name" placeholder="Last name" />
                            </div>
                          </div>
                          <div className="col-12 mb-3">
                            <label className={`${userStyle.profilepageLabel} form-label`}>Position</label>
                            <input type="text" className={`${userStyle.profilepageInputs} form-control`} onChange={handleChange} value={user.position} name="position" placeholder="Position" />
                          </div>
                          <div className="col-12 mb-3">
                            <label className={`${userStyle.profilepageLabel} form-label`}>Email Address</label>
                            <input
                              type="email"
                              className={`${userStyle.profilepageInputs} form-control ${emailError ? 'is-invalid' : ''}`}
                              onChange={handleChange}
                              value={user.email_id}
                              name="email_id"
                              placeholder="Email Address"
                            />
                            {emailError && (
                              <div className="invalid-feedback">
                                {emailError}
                              </div>
                            )}
                          </div>
                          <div className="col-12 mb-3">
                            <label className={`${userStyle.profilepageLabel} form-label`}>Phone Number</label>
                            <input
                              type="tel"
                              className={`${userStyle.profilepageInputs} form-control ${phoneError ? 'is-invalid' : ''}`}
                              onChange={handleChange}
                              value={user.phone}
                              name="phone"
                              placeholder="123-456-7890"
                              minLength="10"
                              maxLength="15"
                            />
                            {phoneError && (
                              <div className="invalid-feedback">
                                {phoneError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-12">
                        <hr />
                      </div>
                    </div>
                    <h4> School/Organization Information </h4>
                    <div className="row">
                      <div className="col-lg-3">
                        <div className={userStyle.profilepageUpload}>
                          <div className={userStyle.profilepageEdit}>
                            <input
                              type="file"
                              className={userStyle.profilepageInput}
                              id="profileUpload1"
                              accept=".png, .jpg, .jpeg"
                              onChange={handleOrganizationImageChange}
                            />
                            <label htmlFor="profileUpload1"></label>
                          </div>
                          <div className={userStyle.profilepagePreview}>
                            <div id="profilepreview1">
                              {organizationImage && (
                                <img
                                  src={organizationImage}
                                  alt="Organization Preview"
                                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className={userStyle.profilepageschoolContent}>
                          <div className="row">
                            <div className="col-12 mb-3">
                              <label className={`${userStyle.profilepageschoolLabel} form-label`}>School/Organization Name</label>
                              <input type="text" className={`${userStyle.profilepageschoolInput} form-control`} onChange={handleChange} value={user.organization_name} name="organization_name" placeholder="" />
                            </div>
                          </div>
                          <div className="col-12 mb-3">
                            <label className={`${userStyle.profilepageschoolLabel} form-label`}>Street Address</label>
                            <input type="text" className={`${userStyle.profilepageschoolInput} form-control`} onChange={handleChange} value={user.st_address} name="st_address" placeholder="" />
                          </div>
                          <div className="row">
                            <div className="col mb-3">
                              <label className={`${userStyle.profilepageschoolLabel} form-label`}>City</label>
                              <input type="text" className={`${userStyle.profilepageschoolInput} form-control`} onChange={handleChange} value={user.city} name="city" placeholder="" />
                            </div>
                            <div className="col mb-3">
                              <label className={`${userStyle.profilepageschoolLabel} form-label`}>State</label>
                              <select className={`${userStyle.profilepageschoolSelect} form-select`}>
                                <option> -Select- </option>
                                <option value="Alabama-AL"> Alabama </option>
                                <option value="Arizona-AZ"> Arizona </option>
                                <option value="Arkansas-AR"> Arkansas </option>
                                <option value="California-CA"> California </option>
                                <option value="Colorado-CO"> Colorado </option>
                                <option value="Connecticut-CT"> Connecticut </option>
                                <option value="Delaware-DE"> Delaware </option>
                                <option value="Florida-FL"> Florida </option>
                                <option value="Georgia-GA"> Georgia </option>
                                <option value="Idaho-ID"> Idaho </option>
                                <option value="Illinois-IL"> Illinois </option>
                                <option value="Indiana-IN"> Indiana </option>
                                <option value="Iowa-IA"> Iowa </option>
                                <option value="Kansas-KS"> Kansas </option>
                                <option value="Kentucky-KY"> Kentucky </option>
                                <option value="Louisiana-LA"> Louisiana </option>
                                <option value="Maine-ME"> Maine </option>
                                <option value="Maryland-MD"> Maryland </option>
                                <option value="Massachusetts-MA"> Massachusetts </option>
                                <option value="Michigan-MI"> Michigan </option>
                                <option value="Minnesota-MN"> Minnesota </option>
                                <option value="Mississippi-MS"> Mississippi </option>
                                <option value="Missouri-MO"> Missouri </option>
                                <option value="Montana-MT"> Montana </option>
                                <option value="Nebraska-NE"> Nebraska </option>
                                <option value="Nevada-NV"> Nevada </option>
                                <option value="New Hampshire-NH"> New Hampshire </option>
                                <option value="New Jersey-NJ"> New Jersey </option>
                                <option value="New Mexico-NM"> New Mexico </option>
                                <option value="New York-NY"> New York </option>
                                <option value="North Carolina-NC"> North Carolina </option>
                                <option value="North Dakota-ND"> North Dakota </option>
                                <option value="Ohio-OH"> Ohio </option>
                                <option value="Oklahoma-OK"> Oklahoma </option>
                                <option value="Oregon-OR"> Oregon </option>
                                <option value="Pennsylvania-PA"> Pennsylvania </option>
                                <option value="Rhode Island-RI"> Rhode Island </option>
                                <option value="South Carolina-SC"> South Carolina </option>
                                <option value="South Dakota-SD"> South Dakota </option>
                                <option value="Tennessee-TN"> Tennessee </option>
                                <option value="Texas-TX"> Texas </option>
                                <option value="Utah-UT"> Utah </option>
                                <option value="Vermont-VT"> Vermont </option>
                                <option value="Virginia-VA"> Virginia </option>
                                <option value="Washington-WA"> Washington </option>
                                <option value="West Virginia-WV"> West Virginia </option>
                                <option value="Wisconsin-WI"> Wisconsin </option>
                                <option value="Wyoming-WY"> Wyoming </option>
                                <option value="District of Columbia-DC"> District of Columbia </option>
                              </select>
                            </div>
                            <div className="col mb-3">
                              <label className={`${userStyle.profilepageschoolLabel} form-label`}>Zip</label>
                              <input
                                type="text"
                                className={`${userStyle.profilepageschoolInput} form-control ${zipError ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                                value={user.zipcode}
                                name="zipcode"
                                placeholder=""
                                maxLength="9"
                              />
                              {zipError && (
                                <div className="invalid-feedback">
                                  {zipError}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-lg-12">
                        <hr />
                      </div>
                    </div>
                    <h4> Username and Password </h4>
                    <div className="row">
                      <div className="col-lg-3"></div>
                      <div className="col-lg-9">
                        <div className={userStyle.profileuserContent}>
                          <div className="row">
                            <div className="col-12 mb-3">
                              <label className={`${userStyle.profileuserLabel} form-label`}>Username</label>
                              <input type="text" className={`${userStyle.profileuserInput} form-control`} onChange={handleChange} value={user.email_id} name="email_id" placeholder="" />
                            </div>
                          </div>
                          <div className="col-12 mb-3">
                            <label className={`${userStyle.profileuserLabel} form-label`}>Password</label>
                            <div className={userStyle.profilepasswordWrapper}>
                              <input
                                type={isPasswordVisible ? "text" : "password"}
                                id="password"
                                className={`${userStyle.profileuserInput} form-control ${passwordError ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                                value={user.password}
                                name="password"
                              />
                              <div className={userStyle.profiletoggleButton} onClick={togglePasswordVisibility}>
                                {isPasswordVisible ? <FaEyeSlash className={userStyle.profileIconeye} /> : <FaEye className={userStyle.profileIconeye} />}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 mb-4">
                            <label className={`${userStyle.profileuserLabel} form-label`}>Confirm Password</label>
                            <div className={userStyle.profilepasswordWrapper}>
                              <input
                                type={isCPasswordVisible ? "text" : "password"}
                                id="confirmPassword"
                                name="confirmPassword"

                                className={`${userStyle.profileuserInput} form-control ${passwordError ? 'is-invalid' : ''}`}
                                onChange={handleChange}
                              // Optional: Prevent user from editing if auto-filled
                              />
                              <div className={userStyle.profiletoggleButton} onClick={toggleCPasswordVisibility}>
                                {isCPasswordVisible ? <FaEyeSlash className={userStyle.profileIconeye} /> : <FaEye className={userStyle.profileIconeye} />}
                              </div>
                            </div>
                            {passwordError && (
                              <div className="invalid-feedback d-block">
                                {passwordError}
                              </div>
                            )}
                          </div>
                          <div className="col-12 text-center">
                            <button className={`${userStyle.profilemainButton} btn btn-primary`}>Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}